import React from 'react';
import '../styles/Footer.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-logo">
            <h3>聯漢室內設計</h3>
            <p>創造有溫度的空間，打造理想的生活環境</p>
          </div>
          <div className="footer-links">
            <div className="footer-links-column">
              <h4>快速連結</h4>
              <ul>
                <li><Link to="/">首頁</Link></li>
                <li><Link to="/#about">關於聯漢</Link></li>
                <li><Link to="/#services">服務項目</Link></li>
                <li><Link to="/#process">服務流程</Link></li>
                <li><Link to="/#projects">精選案例</Link></li>
                <li><Link to="/#contact">聯絡我們</Link></li>
              </ul>
            </div>
            <div className="footer-links-column">
              <h4>高雄辦公室</h4>
              <ul>
                <li>地址：高雄市鳥松區大華路214巷6號</li>
                <li>電話：<a href="tel:0921-233-330">0921-233-330</a></li>
                <li>電話：<a href="tel:0970-747-330">0970-747-330</a></li>
                <li>Email：<a href="mailto:lingchun16@yahoo.com.tw">lingchun16@yahoo.com.tw</a></li>
              </ul>
            </div>
            <div className="footer-links-column">
              <h4>台東辦公室</h4>
              <ul>
                <li>地址：台東縣台東市衡陽路128巷40號</li>
                <li>電話：<a href="tel:0921-233-330">0921-233-330</a></li>
              </ul>
            </div>
            <div className="footer-links-column">
              <h4>營業時間</h4>
              <table className="footer-hours-table">
                <tbody>
                  <tr><td>週一至週六</td><td>08:00–23:30</td></tr>
                  <tr><td>週日</td><td>休息</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="copyright">
            <p>&copy; {currentYear} 聯漢室內設計有限公司 All Rights Reserved.</p>
          </div>
          <div className="social-links">
            <a href="https://www.facebook.com/lanhung.interiordesign/" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Facebook">
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
            <a href="https://www.instagram.com/lanhung_interior" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            {/* <a href="https://line.me/" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Line">
              <FontAwesomeIcon icon={faLine} />
            </a> */}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 